import OneDay from 'apps/OneDay'
import { getCommonStaticProps } from 'commonPage'
import commonMessages from 'lang/es/common'

export default OneDay

export async function getStaticProps() {
  const commonStaticProps = await getCommonStaticProps()
  const messages = {
    ...commonMessages,
  }

  return {
    props: {
      titleMeta: 'ONEDAY_TITLE',
      descriptionMeta: 'ONEDAY_BRANCHES_DESCRIPTION',
      headerProps: {
        activeIndex: 4,
        showBackButton: false,
        whatsappMessage: {
          id: 'VTA_WHATSAPP_MESSAGE',
          whatsappVTA: true,
        },
        variantWhatsappPhone: 'clikauto',
      },
      messages,
      ...commonStaticProps,
    },
  }
}
